<template>
  <section>
    <div :style="{borderColor: $store.getters.clientStyle.primary}"
      class="global-question-card container global-question-card-padding"
      @mouseover="comment.questionIsFocussed=true"
      @mouseleave="() => {if (questionData.comment==1) this.$refs.commentBox.leaveComment()}">

      <!-- Component for question title, description, number and required indicator -->
      <question-header />

      <!-- Specific markup for this question type -->
      <div class="columns global-answer-padding">

        <div class="column is-full">

          <div class="field" v-if="questionData.question_type == 'checkbox'">
            <p-check class="p-default p-curve p-fill p-smooth p-bigger is-size-5 p-icon checkbox-option single-checkbox" :name="questionData.name" :value="questionData.name" v-model="options[0].selected" @change="saveAnswer()"><i class="icon fas fa-check check-icon" slot="extra"></i>{{ checkboxValue }}</p-check>

          </div>

          <div v-if="questionData.question_type == 'checkbox_multiple_multiple'">
            <div
            v-for="(value, index) in questionData.values"
            :key="index"
            class="field">

              <p-check class="p-default p-curve p-fill p-smooth p-bigger is-size-5 p-icon checkbox-option" :name="value" :value="value" v-model="options[index].selected" @change="saveAnswer()"><i class="icon fas fa-check check-icon" slot="extra"></i></p-check>
              <p class="is-size-5 checkbox-option long-value" @click="updateAnswer(value, index)">{{ value }}</p>
            </div>
          </div>

        </div>

        <!-- button area (right side of question card) -->
        <question-options v-if="questionData.comment==1"/>

      </div>
    </div>

    <!-- Comment component to be redered when comments are allowed for this question -->
    <comment-box ref="commentBox" v-if="questionData.comment=='1'" />
  </section>
</template>

<script>
import QuestionHeader from './QuestionHeader'
import QuestionOptions from './QuestionOptions'
import CommentBox from './CommentBox'


export default {
  components: {
    'question-header': QuestionHeader,
    'question-options': QuestionOptions,
    'comment-box': CommentBox
  },
  props: {
    questionData: Object, // eslint-disable-line vue/require-default-prop
    number: Number // eslint-disable-line vue/require-default-prop
  },
  data () {
    return {
      // radio: 'default',
      options: [],
      uploads: [],
      isAnswered: false,
      comment: {
        showComment: false,
        commentFocussed: false,
        questionIsFocussed: false
      }
    }
  },
  created () {
    // this.options = [];
    let answers = this.questionData.answer
    let result = []
    
    if (this.questionData.values.length > 0) {
      this.questionData.values.forEach((value, index) => {
        let answer = {
          name: value,
          selected: false
        }

        if (!this.questionData.answer) this.questionData.answer = []
        for (let i=0; i<this.questionData.answer.length; i++) {
          if (answers[i] === value) {
            answer.selected = true
            break
          }
        }
        result.push(answer)
      })
    } else {
      let answer = {
        name: 'check',
        selected: this.questionData.answer
      }
      result.push(answer)
    }

    this.options = result
    
  },
  methods: {
    saveAnswer () {
      
      if (this.questionData.values.length > 0) {
        let answers = this.options.filter((option) => {
          return option.selected === true
        })
        
        let result = []
        answers.forEach((answer) => result.push(answer.name))
        this.questionData.answer = result
        
        // console.log(result);
      } else {
        this.questionData.answer = this.options[0].selected
      }

      this.isAnswered = true
     
      this.$store.commit('updateActivity', this.$store.getters.getActivities)
      // console.log(JSON.parse(localStorage.getItem('activities')))
    },
    updateAnswer (value, index) {
      this.options[index].selected = !this.options[index].selected;      
      this.saveAnswer()
    }
  },
  computed: {
    checkboxValue () {
      return (this.options[0].selected) ? 'Aangevinkt' : 'Niet aangevinkt'
    }
  },
  provide () {
    return {
      question: this.questionData,
      number: this.number,
      comment: this.comment,
      uploads: this.uploads
    }
  }
}

</script>

<style scoped>

.checkbox-option {
  margin-bottom: 15px;
  margin-top: -40px;
}

.single-checkbox {
  color: #acacac;
}

.check-icon {
  color: white;
}

.pretty.p-icon .state .icon {
    position: absolute;
    font-size: 0.9em !important;
    width: calc(1em + 9px);
    height: calc(1em + 20px);
}
</style>



// WEBPACK FOOTER //
// src/components/elements/CheckboxQuestion.vue